export default __webpack_public_path__ + "static/media/sim-taormina.35ff9468.jpg";